import { ThemeToggle } from "./ThemeToggle";
import styles from "./TopBar.module.css";

export function TopBar() {
  return (
    <header className={styles.topbar}>
      <div className={styles.brandGroup}>
        <span className={`${styles.wordmarkLogo} logo-glow`}>
          <img src="/ripper-logo.svg" alt="ripper" className={styles.wordmarkSvg} />
        </span>
        <span className={styles.product}>bite back</span>
        <span className={styles.divider}>·</span>
        <span className={styles.contextMuted}>acme acquiring</span>
      </div>
      <div className={styles.rightGroup}>
        <ThemeToggle />
        <UserChip name="m.rodriguez" org="acme" />
      </div>
    </header>
  );
}

function UserChip({ name, org }: { name: string; org: string }) {
  const initial = name.charAt(0).toUpperCase();
  return (
    <button type="button" className={styles.userChip} aria-label={`${name} at ${org}`}>
      <span className={styles.userAvatar}>{initial}</span>
      <span className={styles.userName}>{name}</span>
      <span className={styles.userCaret}>▾</span>
    </button>
  );
}
